import { cn } from "../../helpers";

export type MessageCardVariant =
  | "default"
  | "info"
  | "error"
  | "plain"
  | "elevated"
  | "promotion";

const animation =
  "animate-in ease-out duration-500 fade-in slide-in-from-top-6";

const variantContainer: Record<MessageCardVariant, string> = {
  default: "bg-neutral-50 text-neutral-700",
  info: "bg-[#DDE1FC] text-[#030C6D]",
  error: "bg-red-100 text-[#BF1720]",
  plain: "bg-neutral-50",
  elevated:
    "bg-neutral-50 shadow-neutral-below-small h-[6.5rem] w-full relative overflow-hidden gap-3 px-5",
  promotion: "bg-neutral-50 w-full md:w-[36.75rem]",
};

const variantTitle: Record<MessageCardVariant, string> = {
  default: "text-[#21201C]",
  info: "text-[#030C6D]",
  error: "text-[#BF1720]",
  plain: "",
  elevated: "",
  promotion: "",
};

const variantText: Record<MessageCardVariant, string> = {
  default: "text-neutral-700",
  info: "text-[#030C6D]",
  error: "text-[#BF1720]",
  plain: "",
  elevated: "text-neutral-700",
  promotion: "text-neutral-700",
};

const root = (
  variant: MessageCardVariant = "default",
  className?: string,
  opts?: { extraVerticalPadding?: boolean; animated?: boolean },
) =>
  cn(
    "flex items-center gap-4 rounded-2xl px-4",
    opts?.extraVerticalPadding ? "py-6" : "py-4",
    opts?.animated !== false ? animation : null,
    variantContainer[variant],
    className,
  );
const contentContainer = cn(
  "flex w-full flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between",
);
const titleAndDescriptionContainer = (
  hasTitle: boolean,
  variant: MessageCardVariant = "default",
) =>
  cn(
    "flex flex-col",
    variant === "promotion" ? "gap-2" : "gap-1",
    hasTitle ? null : "justify-center",
  );
const descriptionContainer = (hasSecondDescription: boolean) =>
  cn("flex flex-col", hasSecondDescription ? "gap-4" : "gap-3");
const ctaContainer = cn("flex shrink-0");
const title = (variant: MessageCardVariant = "default") =>
  variantTitle[variant];
const description = (variant: MessageCardVariant = "default") =>
  variantText[variant];

export {
  contentContainer,
  ctaContainer,
  description,
  descriptionContainer,
  root,
  title,
  titleAndDescriptionContainer,
};
